// Module
var code = "<lists-dashboard ng-if=$ctrl.canInit component-is-ready=$ctrl.componentIsReady()></lists-dashboard>";
// Exports
module.exports = code;